import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getTimeline } from "../../models/CandidatesModel";
import {
  buildTimelineLink,
  formatTimelineDate,
  getTimelineEventMeta,
} from "../../helpers/CandidateTimelineHelper";

export default function CandidateTimeline({ candidateId, userToken }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!candidateId || !userToken) {
      setEvents([]);
      return;
    }

    let cancelled = false;

    const fetchTimeline = async () => {
      setLoading(true);
      try {
        const rows = await getTimeline(userToken, candidateId);
        if (!cancelled) {
          setEvents(Array.isArray(rows) ? rows : []);
        }
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setEvents([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchTimeline();

    return () => {
      cancelled = true;
    };
  }, [candidateId, userToken]);

  if (!candidateId) {
    return null;
  }

  return (
    <div className="card custom-card mt-3 candidate-unified-timeline">
      <div className="card-header bg-primary">
        <div className="card-title mb-0 text-white">Unified Timeline</div>
      </div>
      <div className="card-body overflow-auto">
        {loading ? (
          <div className="text-muted small">
            <span className="spinner-border spinner-border-sm me-2" />
            Loading timeline…
          </div>
        ) : events.length === 0 ? (
          <div className="text-muted small">No timeline events yet.</div>
        ) : (
          <ul className="candidate-timeline-list list-unstyled mb-0">
            {events.map((event) => {
              const meta = getTimelineEventMeta(event.type);
              const link = buildTimelineLink(event);

              return (
                <li
                  key={event.id}
                  className={`candidate-timeline-item candidate-timeline-item--${meta.tone}`}
                >
                  <div className="candidate-timeline-marker">
                    <i className={meta.icon} />
                  </div>
                  <div className="candidate-timeline-content">
                    <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                      <span className={`badge candidate-timeline-badge candidate-timeline-badge--${meta.tone}`}>
                        {meta.label}
                      </span>
                      <span className="candidate-timeline-date">
                        {formatTimelineDate(event.occurred_at)}
                      </span>
                    </div>
                    <div className="fw-semibold">{event.title}</div>
                    {event.description ? (
                      <div className="text-muted small mt-1">{event.description}</div>
                    ) : null}
                    <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                      {event.actor ? (
                        <span className="badge bg-light text-dark">
                          <i className="ri-user-3-fill me-1" />
                          {event.actor}
                        </span>
                      ) : null}
                      {link ? (
                        <Link to={link} className="small">
                          View details
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
